
// const API_ROOT = 'https://app-node.talkfintech.com:3016';
const API_ROOT = 'https://app-node.talkgovtech.com:3022';
// const API_ROOT = 'http://localhost:3022';

//  const root_data = "https://talkfintech.ondotmail.com/updatedPostData/postData.json";

// const webPath = 'https://talkfintech.com'
const webPath = 'https://talkgovtech.com'
// const webPath = 'https://enterprisetalk.com'  // for image testing only

export { API_ROOT, webPath };